import { useAuthStore } from '@/store/auth';

export const useAccess = () => {
  const { currentUser } = useAuthStore();
  return {
    canAdmin: currentUser?.isAdmin === true,
    normalUser: currentUser?.isAdmin === false,
    is_aspice_specialist: Boolean(currentUser?.isAspiceSpecialist),
    canUseAI: Boolean(currentUser?.isAiEnabled),
  };
};
